import React, { Fragment, useState, useEffect } from 'react';
import { Card, Col, Button } from 'reactstrap';
import { useAgreement } from '../../../hooks/agreements/useAgreement';
import { ModalAgreement } from '../../../components/agreement/ModalAgreement';
import './StyleAgreementCard.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { Dialog } from 'primereact/dialog';





export const IndexAgreements = () => {

    const {

        // ? DATA 
        modal, modalTitle, toggle, method, loading, name_company, contract_number, validity, status,
        navigateNewAgreement, navigateUpdate, agreements,

        // ? METHODS GLOBALS
        handleDelete, saveDelete, handleUpdateStatus, saveUpdateStatus,

        //*dowload excel 
        downdloadExcel, exportExcel, id_branch,


        // * DELETE AGREEMENT
        confirmationDelete, isDelete, valueCode, setValueCode,


        // * CONFIGURATION HISTORIC
        handleViewCompany, loadingHistoric, labelAgreement, labeldataCustomer, modalviewHistoric, toggleHistoric

    } = useAgreement();


    const headerStyle =
    {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "10px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle =
    {
        fontSize: "10px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };


    const renderPayMethod = (items) => {

        const baseStyle = { fontSize: "12px", textAlign: "center" };

        const _status = items.status

        if (_status) {
            return <span className="status-approved">
                Aprobado
            </span>;
            // <Tag style={baseStyle} severity="success" value={"Aprobado"} />;
        }
        else {
            return <span className="status-resived">
                Revisión
            </span>;
            //  <Tag style={baseStyle} severity="warning" value={"Revisión"} />;
        }
    };


    const renderExpiration = (items) => {
        const expired = items.expiracion;

        return (
            <span className={expired ? "badge-no" : "badge-yes"}>
                {expired ? "NO" : "SI"}
            </span>
        );
    };


    const [globalFilter, setGlobalFilter] = useState("");


    useEffect(() => {
        const savedFilter = localStorage.getItem('globalFilter');
        if (savedFilter) {
            setGlobalFilter(savedFilter);
        }
    }, []);

    useEffect(() => {
        if (globalFilter) {
            localStorage.setItem('globalFilter', globalFilter);
        } else {
            localStorage.removeItem('globalFilter');
        }
    }, [globalFilter]);


    const handleClearFilter = () => {
        setGlobalFilter("");
    };



    const filterData = (data, filter) => {
        return data.filter(row => {

            const name_company = row?.name_company ?? "-----";
            const contract_number = row?.contract_number ?? "-----";
            const financing_method_name = row?.financing_method_name ?? "-----";
            const validity = row?.validity ?? "-----";
            const agreement_mode = row?.agreement_mode ?? "-----";
            const lowerCaseFilter = filter.toLowerCase();



            return (
                name_company.toLowerCase().includes(lowerCaseFilter) ||
                contract_number.toLowerCase().includes(lowerCaseFilter) ||
                financing_method_name.toLowerCase().includes(lowerCaseFilter) ||
                validity.toLowerCase().includes(lowerCaseFilter) ||
                agreement_mode.toLowerCase().includes(lowerCaseFilter)
            );
        });
    };



    return (
        <Fragment>
            <div className='container-global-zoom' >
                <Card  >
                    <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                        <TitleDataTable
                            titleTable="Listado de convenios"
                            buttonActions={exportExcel}
                            titleButton="Descargar listado"
                            isDisbled={false}
                            titleCreate="Crear convenio"
                            buttonActionsCreate={navigateNewAgreement}
                            actionInput={setGlobalFilter}
                            valueFilter={globalFilter}
                            filterLocalStorage={true}
                            cleanFilterLocalStorage={handleClearFilter}
                        />
                    </Col>

                    <Col sm="12" className='pt-3'>

                        <div className="table-responsive" >
                            <DataTable
                                className="data-table"
                                value={filterData(agreements, globalFilter)}
                                paginator
                                rows={10}
                                emptyMessage={
                                    <div className="text-center">
                                        <img
                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                            style={{ width: "25%" }}
                                            alt="Sin Muestras"
                                        />
                                        <br />
                                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                            No hay un registro.
                                        </p>
                                    </div>
                                }
                                rowsPerPageOptions={[10, 50, 100]}
                                stripedRows
                                responsiveLayout="scroll"

                            >
                                <Column
                                    body={(rowData, { rowIndex }) => rowIndex + 1}
                                    header="#"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    sortable
                                    field='id_agreement'
                                />
                                <Column
                                    body={(rowData) => (
                                        <label style={{ fontSize: "11px", textAlign: "center", fontWeight: "bold" }}>
                                            {rowData?.contract_number ?? "-----"}
                                        </label>
                                    )}
                                    header="N° de contrato"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    sortable
                                    field="contract_number"
                                />
                                <Column
                                    body={(rowData) => (
                                        <label style={{ fontSize: "11px", textAlign: "center" }}>
                                            {rowData?.name_company ?? "-----"}
                                        </label>
                                    )}
                                    header="Empresa"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    sortable
                                    field="name_company"
                                />
                                <Column
                                    body={(rowData) => (
                                        <label style={{ fontSize: "11px", textAlign: "center" }}>
                                            {rowData?.method_of_payment ?? "-----"}
                                        </label>
                                    )}
                                    header="Esquema de cobro"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    sortable
                                    field="method_of_payment"
                                />
                                <Column
                                    body={(rowData) => (
                                        <label style={{ fontSize: "11px", textAlign: "center" }}>
                                            {rowData?.credit_days ?? "-----"}
                                        </label>
                                    )}
                                    header="Plazo de crédito"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    sortable
                                    field="credit_days"
                                />
                                <Column
                                    sortable
                                    field="agreement_mode"
                                    header="Modo de convenio"
                                    body={(rowData) => (
                                        <div className="d-flex justify-content-center">
                                            <div className="agreement-container">

                                                <span className="agreement-chip">
                                                    {rowData.agreement_mode}
                                                </span>

                                                {rowData.agreement_mode === "Tarifario Madre" &&
                                                    Number(rowData.agreement_discount_global) > 0 && (
                                                        <span className="discount-chip">
                                                            {rowData.agreement_discount_global}%
                                                        </span>
                                                    )
                                                }

                                            </div>
                                        </div>
                                    )}
                                />
                                {/* <Column
                                    body={(rowData) => (
                                        <span className="agreement-chip">
                                            {rowData?.agreement_mode}
                                        </span>

                                    )}
                                    header="Modo de convenio"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    sortable
                                    field="agreement_mode"
                                /> */}
                                <Column
                                    header="Vigencia"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    body={(rowData) => (
                                        <div className="d-flex justify-content-center">
                                            {renderExpiration(rowData)}
                                        </div>
                                    )}
                                    sortable
                                    field="expiracion"
                                />
                                <Column
                                    body={(rowData) => (
                                        <label style={{ fontSize: "11px", textAlign: "center" }}>
                                            {rowData?.validity ?? "-----"}
                                        </label>
                                    )}
                                    header="Validos hasta"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    sortable
                                    field="validity"
                                />

                                <Column
                                    header="Estatus"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    body={(rowData) => (
                                        <div className="d-flex justify-content-center">
                                            {renderPayMethod(rowData)}
                                        </div>
                                    )}
                                    sortable
                                    field="status"
                                />



                                <Column
                                    header="Acciones"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    body={(rowData) => {
                                        const objId = rowData.id_agreement;
                                        return (
                                            <div className="d-flex justify-content-center">
                                                <button
                                                    onClick={() => handleUpdateStatus(rowData.id_agreement)}
                                                    title={rowData.status ? "Desactivar" : "Activar"}
                                                    style={{
                                                        width: "30px",
                                                        height: "30px",
                                                        fontSize: "0.65rem",
                                                        borderRadius: "8px",
                                                        padding: "0",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginRight: "3px"
                                                    }}
                                                    className={`btn ${rowData.status ? 'btn-successs' : 'btn-naranja '}`}
                                                >
                                                    {rowData.status ? <i className='icofont icofont-ui-check'></i> : <i className='fa fa-times  '></i>}
                                                </button>

                                                {!rowData.status && (
                                                    <button
                                                        onClick={() => navigateUpdate(rowData.id_agreement)}
                                                        title="Editar"
                                                        style={{
                                                            width: "30px",
                                                            height: "30px",
                                                            fontSize: "0.65rem",
                                                            borderRadius: "8px",
                                                            padding: "0",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            marginRight: "3px"
                                                        }}
                                                        className={`btn btn-secondary`}
                                                    >
                                                        <i className="icofont icofont-ui-edit f-14"></i>
                                                    </button>
                                                )}

                                                <button
                                                    onClick={() => handleDelete(rowData.id_agreement)}
                                                    title="Eliminar"
                                                    style={{
                                                        width: "30px",
                                                        height: "30px",
                                                        fontSize: "0.65rem",
                                                        borderRadius: "8px",
                                                        padding: "0",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginRight: "3px"
                                                    }}
                                                    className={`btn btn-danger`}
                                                >
                                                    <i className="icofont icofont-ui-delete f-14"></i>
                                                </button>

                                                <button
                                                    onClick={() => downdloadExcel(rowData.id_agreement, id_branch, rowData.id_commercial_line)}
                                                    title="Descargar Precios"
                                                    style={{
                                                        width: "30px",
                                                        height: "30px",
                                                        fontSize: "0.65rem",
                                                        borderRadius: "8px",
                                                        padding: "0",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginRight: "3px"
                                                    }}
                                                    className={`btn btn-success`}
                                                >
                                                    <i className="fa fa-file-excel-o f-14"></i>
                                                </button>



                                                <button
                                                    type="button"
                                                    onClick={() => handleViewCompany(rowData.id_agreement, rowData.contract_number)}
                                                    style={{
                                                        backgroundColor: "#074770",
                                                        border: "none",
                                                        color: "#fff",
                                                        cursor: "pointer",
                                                        width: "30px",
                                                        height: "30px",
                                                        fontSize: "0.65rem",
                                                        borderRadius: "8px",
                                                        padding: "0",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    title="Histórico de cambios"
                                                >
                                                    <i className="icofont icofont-history f-16" />
                                                </button>

                                            </div>
                                        );
                                    }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                />
                            </DataTable>
                        </div>
                    </Col>
                </Card>
            </div>
            <ModalAgreement
                {
                ...{
                    modal, modalTitle, toggle, method, loading,
                    name_company, contract_number, validity, status,
                    saveDelete, saveUpdateStatus,
                    confirmationDelete, isDelete, valueCode, setValueCode
                }
                }
            />
            {
                // ? HISTORIC
            }
            <Dialog

                header={
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}
                    >
                        <div
                            style={{
                                width: "34px",
                                height: "34px",
                                borderRadius: "50%",
                                background: "rgba(255,255,255,.15)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <i
                                className="pi pi-history"
                                style={{
                                    color: "#fff",
                                    fontSize: "1rem"
                                }}
                            />
                        </div>

                        <div>
                            <div
                                style={{
                                    fontWeight: "600",
                                    fontSize: "16px"
                                }}
                            >
                                Histórico de cambios
                            </div>

                            <div
                                style={{
                                    fontSize: "11px",
                                    opacity: ".7"
                                }}
                            >
                                Registro de modificaciones
                            </div>
                        </div>
                    </div>
                }

                visible={modalviewHistoric}
                onHide={toggleHistoric}
                modal
                style={{
                    width: "78vw",
                    borderRadius: "16px",
                    overflow: "hidden"
                }}
                headerStyle={{
                    background: "linear-gradient(358deg, rgb(13, 59, 89) 0%, rgb(27, 84, 119) 55%, rgb(46, 100, 133) 100%)",
                    color: "#fff",
                    padding: "18px",
                    borderBottom: "1px solid rgba(255,255,255,.08)"
                }}
                pt={{
                    headerIcon: {
                        style: {
                            color: "#fff"
                        }
                    },
                    content: {
                        style: {
                            padding: "20px",
                            background: "#f8fafc"
                        }
                    }
                }}
                footer={
                    <Button
                        color="danger"
                        onClick={toggleHistoric}
                    >
                        Cerrar
                    </Button>
                }
            >
                <br />
                <div
                    style={{
                        background: "#00294012",
                        borderRadius: "12px",
                        padding: "16px",
                        marginBottom: "16px",
                        borderLeft: "5px solid #0f3d5e",
                        boxShadow: "0px 3px 12px rgba(0,0,0,.08)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >

                    <div>

                        <div
                            style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                color: "#0f3d5e"
                            }}
                        >
                            Historial de cambios del convenio
                        </div>

                        <div
                            style={{
                                fontSize: "12px",
                                color: "#6c757d"
                            }}
                        >
                            {labelAgreement ?? "---"}
                        </div>

                    </div>

                    <div
                        style={{
                            background: "#e8f1f8",
                            color: "#0f3d5e",
                            padding: "8px 14px",
                            borderRadius: "25px",
                            fontSize: "12px",
                            fontWeight: "600"
                        }}
                    >
                        <i
                            className="pi pi-clock mr-2"
                        />
                        {labeldataCustomer?.length ?? 0} movimientos
                    </div>

                </div>

                <DataTable
                    value={labeldataCustomer}
                    paginator
                    rows={10}
                    stripedRows
                    showGridlines
                    className="p-datatable-sm shadow-sm"
                    rowsPerPageOptions={[10, 50, 100]}
                    responsiveLayout="scroll"
                    style={{ fontSize: "11px" }}
                    emptyMessage={
                        <div className="text-center">
                            <img
                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                style={{ width: "20%" }}
                                alt="Sin resultados"
                            />
                            <br />
                            <p className='badge badge-light-primary mt-2' style={{ fontSize: "12px" }}>
                                No se encontraron resultados.
                            </p>
                        </div>
                    }
                >

                    <Column
                        field="create_at"
                        header="Fecha"
                        sortable
                        headerStyle={headerStyle}
                    />

                    <Column
                        field="method"
                        header="Acción"
                        headerStyle={headerStyle}

                        body={(rowData) => (

                            <span
                                style={{
                                    background:
                                        rowData.method === "ACTUALIZAR"
                                            ? "#E3F2FD"
                                            : "#E8F5E9",

                                    color:
                                        rowData.method === "ACTUALIZAR"
                                            ? "#1565C0"
                                            : "#2E7D32",

                                    padding: "6px 12px",
                                    borderRadius: "30px",
                                    fontSize: "11px",
                                    fontWeight: 600
                                }}
                            >
                                <i
                                    className={
                                        rowData.method === "ACTUALIZAR"
                                            ? "pi pi-pencil"
                                            : "pi pi-plus"
                                    }
                                    style={{
                                        marginRight: "5px"
                                    }}
                                />

                                {rowData.method}
                            </span>

                        )}
                    />

                    <Column
                        field="name_user"
                        header="Usuario"
                        headerStyle={headerStyle}

                    />

                    <Column
                        field="site"
                        header="Módulo"
                        headerStyle={headerStyle}

                    />

                    <Column
                        field="field_name"
                        header="Campo"
                        headerStyle={headerStyle}

                    />

                    <Column
                        field="original_information"
                        header="Anterior"
                        headerStyle={headerStyle}

                        body={(rowData) => (

                            <span
                                style={{
                                    color: "#6c757d"
                                }}
                            >
                                {rowData.original_information}
                            </span>

                        )}
                    />

                    <Column
                        field="updated_information"
                        header="Nuevo"
                        headerStyle={headerStyle}

                        body={(rowData) => (

                            <span
                                style={{
                                    color: "#1565C0",
                                    fontWeight: 600
                                }}
                            >
                                {rowData.updated_information}
                            </span>

                        )}
                    />

                </DataTable>

            </Dialog>
        </Fragment >
    )
}
